import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isHulUser: false,
  hulUserData: null,
};

export const hulAuthSlice = createSlice({
  name: 'hulAuth',
  initialState,
  reducers: {
    setHulUser: (state, action) => {
      state.isHulUser = true;
      sessionStorage.setItem("hulUserData", JSON.stringify(action.payload));
      state.hulUserData = action.payload;
    },
    clearHulUser: (state) => {
      state.isHulUser = false;
      state.hulUserData = null;
    },
  },
});

export const { setHulUser, clearHulUser } = hulAuthSlice.actions;

export const hulAuthReducer = hulAuthSlice.reducer;
